






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class NoResult extends Vue {
  @Prop() private message!: string;
}
